import React, { useState } from "react";
import Popup from "./Popup";
import { imageForNft } from "./NftUtils";
import { WalletContext } from "./App";

export default function ShopItem(props: {items: string[] | undefined, id: string, price: number, rarity: string, name: string, desc: string, successFn: any}) {
    const wallet = React.useContext(WalletContext);
    const [isPopup, setIsPopup] = useState(false);
    const [isClicked, setIsClicked] = useState(false);

    const togglePopup = () => {
        setIsPopup(!isPopup);
    }

    const buyItem = async () => {
        setIsClicked(true);
        console.log("buying item...");
        var itembuyResp = await fetch("/.netlify/functions/itembuy", {
            method: 'POST',
            headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
            body: JSON.stringify({
                nft: wallet.player.selectedNft,
                item_id: props.id,
                walletKey: wallet.key,
            })
        });

        console.log(JSON.stringify(itembuyResp.json()));
        if (itembuyResp.ok) {
            togglePopup();
            props.successFn();
        }

    }

    let rarityColor = props.rarity === 'common' ? 'green' : props.rarity === 'rare' ? 'blue' : props.rarity === 'epic' ? 'purple' : props.rarity === 'legendary' ? 'gold' : 'black';

    return (
        <div className='flexColumn' style={{width: '200px', padding: '20px', backgroundColor: '#270238', borderRadius: '20px'}}>
            <div style={{fontSize: '20px', fontWeight: 'bold'}}>{props.name}</div>
            <div>
                <img alt='' src={'shop/item-' + props.id + '.png'} style={{backgroundColor: '#ffbcfe', height: '100px', width: '100px', border: '2px solid ' + rarityColor}}/>
                <div style={{color: rarityColor, fontWeight: 'bold'}}>{props.rarity} item</div>
            </div>
            <div>{props.desc}</div>
            <div className='flexRow' style={{gap: '7px'}}><img alt='' src='/apexcoin.png' height='20px' width='20px'/>{props.price} $APEX</div>
            <div style={{height: '40px'}}>
            {   props.items === undefined ?
                <div style={{marginTop: '10px', color: '#ffce00'}}>loading...</div> :
                props.items.includes(props.id) ?
                <div style={{marginTop: '10px', fontWeight: 'bold', color: '#ffce00'}}>Item Owned :)</div> :
                (wallet.player.tokens && wallet.player.tokens >= props.price ?
                <button className="playButton" onClick={togglePopup}>Buy Item</button> :
                <button className="disabledButton" onClick={togglePopup} disabled={true}>Buy Item</button>)
            }
            </div>
            {isPopup && <Popup handleClose={togglePopup} content={
                <div>
                    <h1 style={{marginTop: '0'}}><b>Buy Item</b></h1>
                    <p>Buy this item for this ApexDucks #{wallet.player.selectedNft} ?</p>

                    <div className='flexRow' style={{marginBottom: '5px'}}>
                        <div>
                            <img alt='' style={{height: '100px', width: '100px', border: 'solid 2px #270238'}} title={'ApexDucks #' + wallet.player.selectedNft} src={imageForNft(wallet.player.selectedNft).replace('-75.png', '-250.png')}/>
                        </div>
                        <div>
                            <img alt='' src={'shop/item-' + props.id + '.png'} style={{backgroundColor: '#ffce00', height: '100px', width: '100px', border: 'solid 2px ' + rarityColor}}/>
                        </div>
                    </div>

                    <div style={{marginTop: '10px'}}>Item: {props.name}</div>
                    <div>Price: {props.price} $APEX</div>

                    <div style={{marginTop: '15px', marginBottom: '15px'}}>The item will be bound to this duck</div>

                    <div style={{height: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        {(isClicked ? <div>Sending...</div> :
                            <button className="playButton" onClick={buyItem}>BUY&nbsp;ITEM</button>)
                        }
                    </div>

                </div>
            }/>}
        </div>
    );
}
